import { parse, isValid } from 'date-fns'
import { dateToUTC } from './utils'

const FormatConfig = {
  separators: ['.', '/', '-'],
  order: [
    ['d', 'M', 'yyyy'], // DD/MM/YYYY
    ['d', 'M', 'yy'], // DD/MM/YY
    ['yyyy', 'M', 'd'], // YYYY-MM-DD
  ],
}

const parseDateInput = (date: string): Date | undefined => {
  const config = FormatConfig
  const allFormats = config.separators.flatMap((separator) => {
    return config.order.map((parts) => parts.join(separator))
  })

  const reference = new Date()

  for (const format of allFormats) {
    const parsed = parse(date, format, reference)
    if (isValid(parsed)) {
      // Create a UTC date to avoid timezone conversion issues
      return dateToUTC(parsed)
    }
  }

  return undefined
}

export default parseDateInput
